import { API_BASE_URL } from "../apiConfig";
import React, { useEffect, useState } from "react";
import "./ComplaintStatus.css";

const ComplaintStatus = () => {
  const [complaints, setComplaints] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);


  useEffect(() => {
    const getCurrentUsername = () => {
      try {
        const sessionStored = sessionStorage.getItem("currentUser");
        if (sessionStored) {
          const userData = JSON.parse(sessionStored);
          if (userData?.role === "user" && userData?.username) return userData.username;
        }
      } catch (err) {
        console.error("Failed to parse session user:", err);
      }

      try {
        const storedUser = localStorage.getItem("user");
        if (storedUser) {
          const userData = JSON.parse(storedUser);
          if (userData?.username) return userData.username;
        }
      } catch (err) {
        console.error("Failed to parse localStorage user:", err);
      }

      return "guest";
    };

    const username = getCurrentUsername();
    const controller = new AbortController();

    const fetchComplaints = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${API_BASE_URL}/api/complaint/get-all`, {
          signal: controller.signal,
        });
        if (!response.ok) {
          throw new Error("Failed to load complaints");
        }
        const data = await response.json();
        const userComplaints = data
          .filter((item) => item.username === username)
          .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

        setComplaints(userComplaints);
      } catch (err) {
        if (err.name !== "AbortError") {
          console.error(err);
          setError("Unable to fetch complaint status at the moment.");
        }
      } finally {
        setLoading(false);
      }
    };

    fetchComplaints();
    return () => controller.abort();
  }, []);

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleString([], {
      month: "short",
      day: "numeric",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  return (
    <div className="complaint-status-shell">
      {/* New Header - Image ke mutabiq */}
      <div className="status-header">
        <div className="left-section">
          <div>
            <p className="status-tag">COMPLAINT STATUS</p>
            <h2>Your Complaint History</h2>
            <p className="status-description">
              Here you can track the latest status of the complaints you submitted.
            </p>
          </div>
        </div>

        <div className="status-summary">
          <span>{complaints.length}</span>
          <small>complaints</small>
        </div>
      </div>

      {loading ? (
        <div className="status-message">Loading your complaint status…</div>
      ) : error ? (
        <div className="status-message status-error">{error}</div>
      ) : complaints.length === 0 ? (
        <div className="status-message">No complaints found yet. Submit a complaint to see updates here.</div>
      ) : (
        <div className="status-grid">
          {complaints.map((complaint) => (
            <div key={complaint._id} className="status-card">
              {/* Image */}
              {complaint.image && (
                <div className="status-image-wrapper">
                  <img
                    src={`${API_BASE_URL}/uploads/${complaint.image}`}
                    alt="Complaint"
                  />
                </div>
              )}

              {/* Content */}
              <div className="card-content">
                <div className="card-header">
                  <div className="left">
                    <div className="icon">📄</div>
                    <div>
                      <h3>{complaint.displayName || "Jadoon submitted the complaint"}</h3>
                      <p className="card-meta">{formatDate(complaint.createdAt)}</p>
                    </div>
                  </div>

                  <span className={`status-pill ${complaint.status?.toLowerCase() || 'pending'}`}>
                    {complaint.status?.toUpperCase() || 'PENDING'}
                  </span>
                </div>

                <p className="complaint-text">
                  {complaint.description || "No description provided."}
                </p>

                <div className="info-row">
                  <div className={`info-box severity-box ${
                    complaint.severity?.toLowerCase().includes('high') ? 'severity-high' : 
                    complaint.severity?.toLowerCase().includes('medium') ? 'severity-medium' : 
                    complaint.severity?.toLowerCase().includes('low') ? 'severity-low' : 
                    complaint.severity?.toLowerCase().includes('no') ? 'severity-no' : 'severity-pending'
                  }`}>
                    <span>SEVERITY</span>
                    <strong>
                      {complaint.severity?.toLowerCase().includes('high') ? 'High' : 
                       complaint.severity?.toLowerCase().includes('medium') ? 'Medium' : 
                       complaint.severity?.toLowerCase().includes('low') ? 'Low' : 
                       complaint.severity?.toLowerCase().includes('no') ? 'No Severity' : 'Pending'}
                    </strong>
                  </div>

                  <div className="info-box location-box">
                    <span>LOCATION</span>
                    <strong>
                      {complaint.location?.lat?.toFixed(4)}, {complaint.location?.lng?.toFixed(4)}
                    </strong>
                  </div>
                </div>

                {complaint.status === "completed" && complaint.proofImage && (
                  <div className="proof-image-section">
                    <p className="proof-title">🧹 Cleanup Proof (Uploaded by Driver)</p>
                    <div 
                      className="proof-image-wrapper"
                      onClick={() => window.open(`${API_BASE_URL}/uploads/proofs/${complaint.proofImage}`, "_blank")}
                      title="Click to view full image"
                    >
                      <img
                        src={`${API_BASE_URL}/uploads/proofs/${complaint.proofImage}`}
                        alt="Cleanup Proof"
                        className="proof-img-thumbnail"
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ComplaintStatus;